module.exports = __webpack_public_path__ + "img/url-bar-120.c3966689.png";